import type React from 'react';
import type { ComponentProps } from 'react';
import Link from 'next/link';
import Styles from './Page.module.scss';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { PATH as DEALS_PATH } from '~/pages/deals';
import { PropertyDealLayout } from '~/components/common/layouts/property_deals/PropertyDealLayout';
import { RelatedDealRow } from '~/components/specifics/property_deals/[id]/RelatedDealRow';
import { RelatedDealListTop } from '~/components/specifics/property_deals/[id]/RelatedDealListTop';
import { usePropertyDeal } from '~/hooks/usePropertyDeals';
import { RelatedDealTotalRow } from '~/components/specifics/property_deals/[id]/RelatedDealTotalRow';
import { useStatuses } from '~/hooks/useStatuses';

type StatusNameMap = { [id: number]: string };
type PageProps = {
  id: number;
};

export const Page: React.FC<PageProps> = ({ id }) => {
  const { data: propertyDeal } = usePropertyDeal(id);
  const { data: statuses } = useStatuses().index();

  if (propertyDeal === null || statuses === null) {
    return null;
  }

  const statusMap: StatusNameMap = {};
  for (const status of statuses) {
    statusMap[status.id] = status.name;
  }

  const items = [
    { label: '案件一覧', href: DEALS_PATH, as: Link },
    { label: '案件グループ' }
  ] as const satisfies ComponentProps<typeof PropertyDealLayout>['items'];
  return (
    <DefaultV2>
      <PropertyDealLayout items={items} propertyDeal={propertyDeal}>
        <div className={Styles.Container}>
          <RelatedDealListTop propertyDeal={propertyDeal} />
          <div className={Styles.DealList}>
            {propertyDeal.deals.map((deal) => (
              <RelatedDealRow
                key={deal.id}
                deal={deal}
                propertyDealId={id}
                statuses={statusMap}
              />
            ))}
          </div>
          <RelatedDealTotalRow propertyDeal={propertyDeal} />
        </div>
      </PropertyDealLayout>
    </DefaultV2>
  );
};
